import React from 'react'
import { MdArrowForward } from "react-icons/md";

interface QuickAccessButton {
    label: string,
    disabled: boolean
}

const QuickAccessButton = ({ label, disabled }: QuickAccessButton) => {
    return (
        <button
            className={`h-[4.125rem] w-full rounded-sm bg-system-primary-10 disabled:opacity-50 disabled:cursor-not-allowed ${disabled ? "" : "cursor-pointer hover:brightness-[90%] hover:shadow-custom-dual transition-all duration-200"}`}
            disabled={disabled}
        >
            <div className='flex justify-between  items-center p-4'>
                <p className='text-blarge text-system-light-100'>{label}</p>
                <MdArrowForward color='#0E6681' size={34} />
            </div>
        </button>
    )
}

export default QuickAccessButton